<template>
  <table class="slds-table slds-no-row-hover slds-table_bordered" v-if="contents.length">
    <thead>
      <tr class="slds-line-height_reset">
        <th scope="col"></th>
        <th scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.description')">
            {{$t('campaignDesigner.contentSelectionAndTag.description')}}
          </div>
        </th>
        <th scope="col">
            <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.tag')">
              {{$t('campaignDesigner.contentSelectionAndTag.contentPriority.label')}}
            </div>
          </th>
        <th scope="col" colspan="3">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.tag')">
            {{$t('campaignDesigner.contentSelectionAndTag.tag')}}
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ContentTableRow
        v-for="(content, index) in localContents"
        :contents="localContents"
        :key="index" :content="content"
        :editable="editable"
        :index="index"
        :tags="tags"
        :ref="`contentRow${index}`"
        @removeContent="$emit('removeContent', { index: $event.index })"
        @tagUpdate="onTagUpdate"
        @update-content-priority="$emit('update-content-priority', $event)" />
    </tbody>
  </table>
</template>
<script>
import ContentTableRow from './ContentTableRow'
export default {
  props: {
    contents: Array,
    editable: Boolean,
    tags: Array
  },
  components: {
    ContentTableRow
  },
  created () {
    this.localContents = this.contents
  },
  data () {
    return {
      localContents: []
    }
  },
  methods: {
    onTagUpdate (event) {
      const { index, position, value } = event
      this.$emit('tagUpdate', { index, position, value })
    },
    validate () {
      return Object.values(this.$refs).every(ref => ref.every(child => child.validate()))
    }
  },
  watch: {
    contents (contents) {
      this.localContents = this.contents
    }
  }
}
</script>
<style lang="scss" scoped>
  th {
    background-color: #005FAA !important;
    color: white !important;
  }
</style>
